var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCorrect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6673 17.0007C33.6673 26.2054 26.2054 33.6673 17.0007 33.6673C7.79591 33.6673 0.333984 26.2054 0.333984 17.0007C0.333984 7.79591 7.79591 0.333984 17.0007 0.333984C26.2054 0.333984 33.6673 7.79591 33.6673 17.0007ZM23.7179 11.9501C24.206 12.4383 24.206 13.2297 23.7179 13.7179L15.3845 22.0512C14.8964 22.5394 14.1049 22.5394 13.6168 22.0512L10.2834 18.7179C9.79528 18.2297 9.79528 17.4383 10.2834 16.9501C10.7716 16.4619 11.563 16.4619 12.0512 16.9501L14.5007 19.3996L18.2254 15.6748L21.9501 11.9501C22.4383 11.4619 23.2297 11.4619 23.7179 11.9501Z",
    fill: "#07BE00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrect);
export default __webpack_public_path__ + "static/media/Correct.8e2ecb28af697cdea525a7cfdaa2e9c8.svg";
export { ForwardRef as ReactComponent };